import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative min-h-[600px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20bright%20school%20classroom%20with%20students%20using%20laptops%20and%20tablets%2C%20natural%20daylight%20streaming%20through%20large%20windows%2C%20white%20walls%20and%20minimal%20design%2C%20teacher%20guiding%20students%2C%20educational%20technology%20screens%20on%20wall%2C%20warm%20and%20inviting%20atmosphere%2C%20clean%20professional%20editorial%20photography%20style&width=1600&height=900&seq=redenet-hero-2027&orientation=landscape"
          alt="Sala de aula moderna com tecnologia educacional"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-900/90 via-primary-800/80 to-primary-900/75" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 text-center">
        <div className="max-w-3xl mx-auto">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/15 text-accent-400 text-xs font-semibold tracking-wide uppercase mb-6 border border-accent-500/25">
            Comércio e Soluções em TI
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-7xl font-bold text-background-50 font-heading leading-tight mb-5">
            REDENET
          </h1>
          <h2 className="text-xl md:text-3xl lg:text-4xl font-semibold text-accent-400 font-heading leading-tight mb-6">
            Transformando a educação com tecnologia
          </h2>
          <p className="text-background-200 text-base md:text-lg max-w-xl mx-auto mb-10 leading-relaxed">
            Desenvolvemos softwares inovadores que conectam escolas, professores, alunos e famílias em uma experiência educacional integrada e moderna.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <Link
              to="/produtos"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-accent-500 text-background-50 text-sm font-semibold hover:bg-accent-600 transition-colors whitespace-nowrap"
            >
              Conheça Nossos Produtos
            </Link>
            <a
              href="https://wa.me/5583998460015"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-background-50/10 text-background-50 text-sm font-semibold hover:bg-background-50/20 transition-colors whitespace-nowrap flex items-center justify-center gap-2 border border-background-50/30"
            >
              <i className="ri-whatsapp-line" />
              Fale Conosco
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent" />
    </section>
  );
}